import { createContext, useContext } from 'react';

import type { HourCyclePreference } from '../topics/time';

export type TooltipTimezone = { zone: string; label: string };

export type TimestampDisplayContextValue = {
  displayZone?: string;
  tooltipTimezones?: TooltipTimezone[];
  /** Formatting reads this from Luxon's default locale; carried here so consumers re-render. */
  hourCyclePreference?: HourCyclePreference;
};

const TimestampDisplayContext = createContext<TimestampDisplayContextValue | null>(null);

export function useTimestampDisplayContext(): TimestampDisplayContextValue | null {
  return useContext(TimestampDisplayContext);
}

export { TimestampDisplayContext };
